import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { getLiquidStakingToken } from 'modules/liquidStaking/methods/getLiquidStakingToken';

import { ILiquidStakingPool } from '../types';

interface ILiquidStakingTokenArgs {
  poolAddress?: Address;
}

export const { useGetLiquidStakingTokenQuery } = api.injectEndpoints({
  endpoints: build => ({
    getLiquidStakingToken: build.query<
      ILiquidStakingPool,
      ILiquidStakingTokenArgs | void
    >({
      queryFn: async params => {
        const { poolAddress } = params || {};

        try {
          const client = getPublicClient();

          return { data: await getLiquidStakingToken(client, poolAddress) };
        } catch {
          const client = getPublicClient();

          return { data: await getLiquidStakingToken(client, poolAddress) };
        }
      },
      providesTags: [cacheTags.liquidStaking],
    }),
  }),
});
